export default {
  // baseURL: 'http://127.0.0.1:3456/' //后端地址
  baseURL: 'https://www.leili.fun:9999/' //后端地址
};
